import React from 'react';
import { Link } from 'react-router-dom';

function Footer(): React.ReactElement {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src="/icons/icon-72x72.png" alt="FancyMyText logo" className="footer-logo-icon" />
              <span className="footer-logo-text">𝓕𝓪𝓷𝓬𝔂𝗠𝘆𝕋𝕖𝕩𝕥</span>
            </Link>
            <p className="footer-description">
              Free Unicode text generator for social media. Transform your text into
              bold, italic, cursive, and 57+ other styles instantly.
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4>Popular Styles</h4>
              <ul>
                <li><Link to="/cursive">Cursive Font Generator</Link></li>
                <li><Link to="/bold">Bold Text Generator</Link></li>
                <li><Link to="/italic">Italic Text Generator</Link></li>
                <li><Link to="/bubble">Bubble Letter Generator</Link></li>
                <li><Link to="/fraktur">Gothic Font Generator</Link></li>
                <li><Link to="/strikethrough">Strikethrough Text</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Text Generators</h4>
              <ul>
                <li><Link to="/aesthetic-fonts">Aesthetic Font Generator</Link></li>
                <li><Link to="/zalgo">Zalgo Text Generator</Link></li>
                <li><Link to="/upside-down">Upside Down Text</Link></li>
                <li><Link to="/small-caps">Small Caps Generator</Link></li>
                <li><Link to="/underline">Underline Text Generator</Link></li>
                <li><Link to="/double-struck">Double Struck Font</Link></li>
                <li><Link to="/monospace">Monospace Font Generator</Link></li>
                <li><Link to="/fullwidth">Vaporwave Text Generator</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Name Generators</h4>
              <ul>
                <li><Link to="/stylish-name-generator">Stylish Name Generator</Link></li>
                <li><Link to="/cute-name-generator">Cute Name Generator</Link></li>
                <li><Link to="/gaming-fonts">Gaming Font Generator</Link></li>
                <li><Link to="/birthday-fonts">Birthday Font Generator</Link></li>
                <li><Link to="/scifi-fonts">Sci-Fi Font Generator</Link></li>
              </ul>
              <h4>More Generators</h4>
              <ul>
                <li><Link to="/bold-generator">Bold Letter Generator</Link></li>
                <li><Link to="/fancy-letter-generator">Fancy Letter Generator</Link></li>
                <li><Link to="/tiny-text">Tiny Text Generator</Link></li>
                <li><Link to="/old-english">Old English Font Generator</Link></li>
                <li><Link to="/fancy-numbers">Fancy Numbers Generator</Link></li>
                <li><Link to="/elegant-fonts">Elegant Font Generator</Link></li>
                <li><Link to="/times-new-roman-font">Times New Roman Font</Link></li>
                <li><Link to="/ransom">Ransom Note Generator</Link></li>
                <li><Link to="/fantasy-fonts">Fantasy Text Generator</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Platforms</h4>
              <ul>
                <li><Link to="/instagram-fonts">Instagram Font Generator</Link></li>
                                <li><Link to="/discord-fonts">Discord Font Generator</Link></li>
                <li><Link to="/twitter-fonts">Twitter (X) Font Generator</Link></li>
                <li><Link to="/">View All 57+</Link></li>
              </ul>
              <h4>Tools</h4>
              <ul>
                <li><Link to="/text-analyzer">Character Counter</Link></li>
                <li><Link to="/case-converter">Case Converter</Link></li>
                <li><Link to="/symbols">Copy Paste Symbols</Link></li>
                <li><Link to="/jawa-translator">Jawa Translator</Link></li>
                <li><Link to="/number-to-words">Number to Words</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Blog</h4>
              <ul>
                <li><Link to="/blog">All Articles</Link></li>
                <li><Link to="/blog/how-to-use-fancy-fonts-instagram">Instagram Bio Guide</Link></li>
                <li><Link to="/blog/best-discord-fonts-username">Discord Username Fonts</Link></li>
                <li><Link to="/blog/top-10-fancy-text-styles">Top 10 Text Styles</Link></li>
              </ul>
              <h4>Info</h4>
              <ul>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/faq">FAQ</Link></li>
                <li><Link to="/compatibility">Compatibility</Link></li>
                <li><Link to="/contact">Contact</Link></li>
                <li><Link to="/app">Install App</Link></li>
                <li><Link to="/privacy">Privacy Policy</Link></li>
                <li><Link to="/terms">Terms of Service</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>{`© ${currentYear} FancyMyText. Free font generator for everyone.`}</p>
            <div className="footer-pwa-badge">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                <path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"/>
              </svg>
              <span>Works offline as PWA</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
